import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    Col,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Modal,
    Row,
} from "reactstrap";
import UserDataService from "../../services/UserDataService";

class UserModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          defaultModal: false,
          users: [],
          perPage: 10,
          currentPage: 1,
          currentUser: {},
          newPasswordNotMatch: false
        };
        this.userDataService = new UserDataService();
    }
      
    async handleInputChanged(e) {
        let { type, name, value, checked } = e.target;
        let val;

        switch (type) {
            case "number":
            case "select-one":
                val = Number(value);
                break;
            case "checkbox":
                if (name.startsWith('role_')) {
                    val = name.replace('role_', '');
                    const currentRoles = this.state.currentUser.Roles || [];
                    
                    if (checked) {
                        if (!currentRoles.includes(val)) {
                            await this.setState(prevState => ({
                                currentUser: {
                                    ...prevState.currentUser,
                                    Roles: [...currentRoles, val]
                                }
                            }));
                        }
                    } else {
                        await this.setState(prevState => ({
                            currentUser: {
                                ...prevState.currentUser,
                                Roles: currentRoles.filter(role => role !== val),
                                // If cashier unchecked, clear warehouse selection
                                warehouse_id: val === 'cashier' ? -1 : prevState.currentUser.warehouse_id
                            }
                        }));
                    }
                }
                break;
            default:
                val = value;
        }

        await this.setState((prevState) => {
            let updatedUser = { ...prevState.currentUser }
            if (!name.startsWith('role_')) {
                updatedUser = { ...prevState.currentUser, [name]: val };
            }
    
            if (name.startsWith('role_') && this.state.currentUser.user_id) {
                const deletedRoles = this.state.previousRoles.filter((role) => !this.state.currentUser.Roles.includes(role));
                updatedUser.DeletedRoles = deletedRoles;
            }
    
            return { currentUser: updatedUser };
        });
    }

    handleResponse(data, successMessage) {
        if (data?.data?.errorMessage) {
            this.setState({ errorMessage: data.data.errorMessage })
        } else if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
              return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.props.toggleModal()
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentUser: {}})
            this.props.fetchData()
        }
        setTimeout(() => {
            this.setState({ successMessage: undefined, errorMessage: undefined });
        }, 5000);   
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        if (charCode === 13) {
            if (this.props.formType === 'edit') {
                this.handleEditUser();
            } else {
                this.handleAddUser();
            }
        }
    }

    validateForm() {
        const { currentUser } = this.state;
        const errors = [];
        const invalidFields = [];

        if (!currentUser?.email || typeof currentUser.email !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentUser.email)) {
            errors.push('Email wajib diisi dan harus valid.');
            invalidFields.push({ field: 'email', value: currentUser?.email });
        }

        if (currentUser?.Roles?.includes("user")) {
            if (!currentUser?.nik || !/^\d+$/.test(String(currentUser.nik))) {
                errors.push('NIK wajib diisi dan harus terdiri dari angka.');
                invalidFields.push({ field: 'nik', value: currentUser?.nik });
            }
        }

        const roles = currentUser?.Roles || [];
        const isCashier = roles.includes('cashier');
        if (isCashier) {
            const wid = currentUser?.warehouse_id;
            if (wid === undefined || wid === null || Number(wid) === -1 || Number.isNaN(Number(wid))) {
                errors.push('Warehouse wajib dipilih untuk role Cashier.');
                invalidFields.push({ field: 'warehouse_id', value: wid });
            }
        }

        if (errors.length > 0) {
            console.error('[UserModal] validateForm failed on field(s):', invalidFields, 'currentUser:', currentUser);
            this.setState({ errorMessages: errors });
            return false;
        }
        this.setState({ errorMessages: [] });
        return true;
    }

    handleAddUser() {
        if (!this.validateForm()) {
            console.warn('[UserModal] handleAddUser blocked: form invalid, see validateForm log above.');
            return;
        }
        this.userDataService.add(this.state.currentUser).then((data) => {
          this.handleResponse(data, "User berhasil ditambahkan");
        })
    }

    handleEditUser() {
        if (!this.validateForm()) {
            console.warn('[UserModal] handleEditUser blocked: form invalid, see validateForm log above.');
            return;
        }
        this.userDataService.update(this.state.currentUser).then((data) => {
            this.handleResponse(data, "User berhasil diubah");
        })
    }

    async setCurrentUser() {
        if (this.props.formType === 'edit') {
            const { currentUser } = this.props;
    
            const { role_id, role_name, ...user } = currentUser;
    
            await this.setState({ 
                currentUser: { 
                    ...user, 
                    Roles: currentUser.Roles ?? [role_name.toLowerCase()] 
                },
                previousRoles: currentUser.Roles ?? [role_name.toLowerCase()]
            });
    
            console.log('test:', JSON.stringify(this.state.currentUser));
        }
    }

    onModalClosed() {
        this.setState({ 
            currentUser: {},
            errorMessages: [],
        })
    }

    handlePasswordMatched(e) {
        const password = this.state.currentUser.password
        const passwordMatch = e.target.value

        if (password !== passwordMatch) {
            return this.setState({ errorMessages: ['Password tidak cocok.'] })
        } 
        this.setState({ errorMessages: [] })
    }

    render() {
        const roleOptions = [
            { id: 'admin', label: 'Admin' },
            { id: 'cashier', label: 'Cashier' },
            { id: 'pengawas', label: 'Pengawas' },
            { id: 'user', label: 'User'}
        ];

        const currentRoles = this.state.currentUser?.Roles || [];
        const isCashier = currentRoles.includes('cashier');

        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.setCurrentUser.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
                >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent">
                        <div className="text-muted text-center mt-2 mb-3">
                            <h3 className="mb-0">{this.props.formType === 'add' ? 'Tambah user baru' : 'Ubah user' }</h3>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                        {this.state.errorMessages && this.state.errorMessages.map((errorMessage) => (
                            <Alert color="danger">
                            {errorMessage}
                            </Alert>
                        ))}
                        {this.state.errorMessage && (
                            <Alert color="danger">
                            {this.state.errorMessage}
                            </Alert>
                        )}
                        <Form role="form">
                        <FormGroup>
                            <Row>
                                <Col lg="6">
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-barcode"
                                    >
                                        Username
                                    </label>
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                            <i className="ni ni-single-02" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input placeholder="Username"
                                        name="username"
                                        value={this.state.currentUser?.username}
                                        onKeyUp={this.onKeyUp.bind(this)}
                                        onChange={this.handleInputChanged.bind(this)}
                                        type="text" />
                                    </InputGroup>  
                                </Col>
                                <Col lg="6">
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-barcode"
                                    >
                                        Roles user
                                    </label>
                                    <div className="pl-3">
                                        {roleOptions.map(role => (
                                            <div className="custom-control custom-checkbox mb-2" key={role.id}>
                                                <input
                                                    className="custom-control-input"
                                                    id={`role_${role.id}`}
                                                    name={`role_${role.id}`}
                                                    type="checkbox"
                                                    checked={currentRoles.includes(role.id)}
                                                    onChange={this.handleInputChanged.bind(this)}
                                                />
                                                <label 
                                                    className="custom-control-label" 
                                                    htmlFor={`role_${role.id}`}
                                                >
                                                    {role.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Row>
                                <Col lg="6">
                                    <label className="form-control-label" htmlFor="input-email">
                                        Email
                                    </label>
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                <i className="ni ni-email-83" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder="Email"
                                            name="email"
                                            type="email"
                                            value={this.state.currentUser?.email || ''}
                                            onKeyUp={this.onKeyUp.bind(this)}
                                            onChange={this.handleInputChanged.bind(this)}
                                        />
                                    </InputGroup>
                                </Col>
                                {currentRoles.includes("user") && (
                                    <Col lg="6">
                                        <label className="form-control-label" htmlFor="input-nik">
                                            NIK
                                        </label>
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-badge" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                placeholder="NIK"
                                                name="nik"
                                                type="text"
                                                value={this.state.currentUser?.nik || ""}
                                                onKeyUp={this.onKeyUp.bind(this)}
                                                onChange={this.handleInputChanged.bind(this)}
                                            />
                                        </InputGroup>
                                    </Col>
                                )}
                            </Row>
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Row>
                                <Col lg="12">
                                    <label
                                    className="form-control-label"
                                    htmlFor="input-name"
                                    >
                                    Warehouse
                                    </label>
                                    <Input
                                        placeholder="Warehouse produk"
                                        name="warehouse_id"
                                        type="select"
                                        disabled={!isCashier}
                                        value={this.state.currentUser.warehouse_id ?? -1}
                                        onChange={this.handleInputChanged.bind(this)}>
                                        <option value='-1'>Warehouse user</option>
                                        {this.props.warehouses.map(warehouse => (
                                            <option key={warehouse.warehouse_id} value={warehouse.warehouse_id}>
                                                {warehouse.warehouse_name}
                                            </option>
                                        ))}
                                    </Input>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Row>
                            
                            <Col lg="6">
                                <label
                                className="form-control-label"
                                htmlFor="input-name"
                                >
                                {this.props.formType === 'add' ? 'Password' : 'Password baru'}
                                </label>
                                <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                    <i className="ni ni-cloud-upload-96" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Password"
                                    name="password"
                                    value={this.state.currentUser?.password}
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    onChange={this.handleInputChanged.bind(this)}
                                    type="password" />
                                </InputGroup>
                            </Col>
                            <Col lg="6">
                                <label
                                className="form-control-label"
                                htmlFor="input-stock"
                                >
                                {this.props.formType === 'add' ? 'Ulangi password' : 'Ulangi password baru'}
                                </label>
                                <InputGroup className={this.state.newPasswordNotMatch ? "input-group-alternative has-danger" : "input-group-alternative"}>
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                    <i className="ni ni-cloud-upload-96" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Ulangi password"
                                    name="password-retype"
                                    onKeyUp={this.onKeyUp.bind(this)}
                                    onChange={this.handlePasswordMatched.bind(this)}
                                    type="password" />
                                </InputGroup>
                            </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <div className="btn-wrapper text-right">
                            <Button
                                className="my-4"
                                color="secondary"
                                type="button"
                                onClick={this.props.toggleModal}
                                >
                                Batal
                            </Button>
                            <Button
                                className="my-4"
                                color="primary"
                                type="button"
                                onClick={() => this.props.formType === 'add' ? this.handleAddUser() : this.handleEditUser()}
                                >
                                Simpan
                            </Button>
                            </div> 
                        </FormGroup> 
                        </Form>
                    </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default UserModal;
